/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalSpecialtyType = {
  type: 'Enum',
} as const;
